import { css } from '@emotion/react';
import { agBorderColor } from '../../../theme/ag-foresight';
import { colors } from '../../../theme/colors';
import { transparentBgStyle } from '../../../theme/component-styles';

/** Card chrome shared by the Deals-tab detail sections — the Summary cards' look
 *  (cardBorderStyles + transparentBgStyle), so both tabs read as one system. */
export const sectionCardCss = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border: 1px solid ${colors.neutral[80]};
  border-radius: 4px;
  background: ${transparentBgStyle.background};

  /* Air between the section title row and the expanded body; :not(hidden) keeps
     collapsed cards from growing a ghost gap. */
  .MuiCollapse-root:not(.MuiCollapse-hidden) {
    margin-top: 12px;
  }
`;

/** Matches the Summary cards' SubSectionTitle (body1 at weight 500). */
export const sectionTitleCss = css`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.15px;
`;

/** Auto-height wrapper for grids that should grow with their rows. */
export const gridAutoCss = css`
  width: 100%;
`;

/** Muted no-rows overlay text, shared by the Deals-detail grids. */
export const gridOverlayMutedCss = css`
  .ag-overlay-no-rows-wrapper {
    color: ${colors.text.secondary};
  }
`;

/**
 * Collapse AgGrid's auto-height viewport floor so populated grids hug their rows.
 * Apply only when rows exist — empty grids keep the default floor so the no-rows
 * overlay has room.
 */
export const gridHugRowsCss = css`
  .ag-layout-auto-height .ag-center-cols-viewport,
  .ag-layout-auto-height .ag-center-cols-container {
    min-height: 36px;
  }
`;

/**
 * Ellipsize Deals-detail grid column headers instead of wrapping them. Pair with
 * `wrapHeaderText: false` / `autoHeaderHeight: false` on the grid's defaultColDef.
 * Scoped to the Deals pane so other grids keep their wrapped headers.
 */
export const gridHeaderEllipsisCss = css`
  .ag-header-cell-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

/**
 * Vertical rule that sets the row-action column apart from the data columns. Drawn one
 * pixel outside the cell so it sits on the same pixel as the header's column separator.
 */
export const gridActionsDividerCss = css`
  .ag-cell[col-id='actions'] {
    box-shadow: -1px 0 0 0 ${agBorderColor};
  }
`;

/**
 * Height of a section card whose body is collapsed: the 24px title row inside the card's
 * 12px padding and 1px border. Loading placeholders take this height so a card that settles
 * collapsed (the usual case for a round without extracted data) does not jump.
 */
export const collapsedCardHeight = 50;
